import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import { MQ_NO_SIDEBAR } from '../../styled';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  ${mediaQuery(MQ_NO_SIDEBAR, 'min')} {
    display: none;
  }
`;

export const OpenButton = styled.label`
  cursor: pointer;
  font-size: 20px;
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;
  &[aria-checked='true'] {
    ~ [data-drawer-content] {
      transition: right 0.3s ease-in-out;
      visibility: visible;
      right: 0;
    }
    ~ [data-drawer-overlay] {
      transition: opacity 0.3s ease-in-out;
      transform: translate(0);
      opacity: 1;
    }
  }
`;

export const Overlay = styled.label`
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
  z-index: 2000;
  cursor: pointer;
  width: 100vw;
  height: 100vh;
  top: 0;
  transform: translate(9999px);
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
`;

export const DrawerClose = styled.label`
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 12px;
  z-index: 1;
  cursor: pointer;
  font-size: 20px;
`;

export const Drawer = styled.div`
  overflow-y: auto;
  transition: right 0.3s ease-in-out;
  right: 0;
  z-index: 2001;
  position: fixed;
  background: ${(props) => props.theme.color.light.default};
  color: ${(props) => props.theme.color.medium.shade};
  max-width: 320px;
  right: -400px;
  width: 85vw;
  top: 0;
  bottom: 0;
`;

export const DrawerContainer = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 72px 24px 24px 24px;
`;

export const LanguageSelectorWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const NotificationsWrapper = styled.div``;
